import { useRouteError, Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";

export function ErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "Unknown error";

  return (
    <div className="mx-auto flex max-w-xl flex-col items-start gap-6 px-6 py-32">
      <p className="text-sm uppercase tracking-widest text-destructive">
        Something went wrong
      </p>
      <h1 className="text-3xl font-semibold tracking-tight">
        This page hit an error.
      </h1>
      <p className="text-sm text-muted-foreground">{message}</p>
      <Button asChild>
        <Link to="/">Go home</Link>
      </Button>
    </div>
  );
}
